import { useEffect, useState } from "react";

export default function PostList({ limit }: { limit?: number }) {
  const [posts, setPosts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPosts() {
      try {
        const response = await fetch("/posts/manifest.json");
        const data = await response.json();
        setPosts(data.posts);
      } catch (error) {
        console.error("Error fetching posts:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchPosts();
  }, []);

  if (loading)
    return (
      <div className="flex justify-center py-8">
        <span className="text-lg font-bold animate-pulse">Loading...</span>
      </div>
    );

  return (
    <div className="flex flex-col gap-6">
      {posts
        .sort(
          (p1, p2) =>
            new Date(p2.date).getTime() - new Date(p1.date).getTime()
        )
        .slice(0, limit)
        .map((post) => (
          <a
            key={post.slug}
            href={`/blog/${post.slug}`}
            className="group flex border-3 border-black bg-white shadow-[5px_5px_0px_0px_#000] hover:shadow-[5px_5px_0px_0px_#ea580c] hover:border-orange-600 transition-all overflow-hidden"
          >
            {post.cover && (
              <img
                src={post.cover}
                alt=""
                className="hidden sm:block w-40 object-cover border-r-3 border-black group-hover:border-orange-600 transition-colors shrink-0"
              />
            )}
            <div className="p-5 flex-1 min-w-0">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3">
                <h3 className="text-lg font-black uppercase tracking-tight group-hover:text-orange-600 transition-colors">
                  {post.title}
                </h3>
                <span className="text-xs font-bold text-black uppercase tracking-widest shrink-0">
                  {new Date(post.date).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}
                </span>
              </div>
              <p className="text-sm leading-relaxed">
                {post.excerpt}
              </p>
              <span className="inline-block mt-3 text-sm font-black uppercase text-orange-600 tracking-wide">
                Read more →
              </span>
            </div>
          </a>
        ))}
    </div>
  );
}
